/**
 * @generated SignedSource<<f28427fabd5c2e8aa469be5bd6b37e52>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectListRightPanelState = "CLOSED" | "OPEN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type OpenTemplatesPanelButton$data = {
  readonly canCreateProject: boolean | null | undefined;
  readonly shouldDisplay?: boolean | null | undefined;
  readonly sidebarExperimentTemplates: {
    readonly totalCount: number;
  };
  readonly userPreferences: {
    readonly __id: string;
    readonly projectListRightPanelState: JiraProjectListRightPanelState | null | undefined;
  };
  readonly " $fragmentType": "OpenTemplatesPanelButton";
};
export type OpenTemplatesPanelButton$key = {
  readonly " $data"?: OpenTemplatesPanelButton$data;
  readonly " $fragmentSpreads": FragmentRefs<"OpenTemplatesPanelButton">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "OpenTemplatesPanelButton",
  "selections": [
    {
      "alias": "canCreateProject",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "type",
          "value": "CREATE_PROJECT"
        }
      ],
      "kind": "ScalarField",
      "name": "canPerform"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "shouldDisplay",
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "type",
              "value": "VIEW_PROJECT_CREATION_ENTRY"
            }
          ],
          "kind": "ScalarField",
          "name": "canPerform"
        }
      ]
    },
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          (v0/*: any*/)
        ],
        "concreteType": "JiraUserPreferences",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "projectListRightPanelState"
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "userPreferences"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "sidebarExperimentTemplates",
        "args": [
          (v0/*: any*/),
          {
            "kind": "Literal",
            "name": "experimentKey",
            "value": "sidebarExperiment"
          }
        ],
        "concreteType": "JiraProjectListViewTemplateConnection",
        "kind": "LinkedField",
        "name": "projectListViewTemplates",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "totalCount"
            },
            "action": "THROW",
            "path": "sidebarExperimentTemplates.totalCount"
          }
        ]
      },
      "action": "THROW",
      "path": "sidebarExperimentTemplates"
    }
  ],
  "type": "JiraQuery"
};
})();

(node as any).hash = "51023cf6ac630616473fcdcdfa416915";

export default node;
